import { FieldOperationsModel } from '../models/FieldOperationsModel';
import { SimplePath } from '../models/SimplePath';
import { Position } from '@turf/helpers';
import { defineStore } from 'pinia';

export const usePathStore = defineStore('paths', {
  // arrow function recommended for full type inference
  state: () => ({
    paths: [] as Array<SimplePath>,
    selectedPath: null as SimplePath | null,
    selectedPathLengthInMeters: null as number | null,
    selectedWorkAreaAreaInSqMeters: null as number | null,
    pathAssociatedField: null as FieldOperationsModel | null,
    currentLine: [] as Position[],
    currentWorkArea: [] as Position[],
    editable: false,
    editWorkArea: false,
    clearMap: false,
    addPath: false,
    revertPath: false,
    revertWorkArea: false,
    deleteWorkArea: false
  }),
  getters: {
    availablePaths(): Array<SimplePath> {
      return this.paths;
    },
    path(): SimplePath | null {
      return this.selectedPath;
    },
    edit(): boolean {
      return this.editable;
    },
    currentPath(): Position[] {
      return this.currentLine;
    },
    addPathMode(): boolean {
      return this.addPath;
    },
    associatedField(): FieldOperationsModel {
      return this.pathAssociatedField as FieldOperationsModel;
    },
    workArea(): Position[] {
      return this.currentWorkArea;
    }
  },
  actions: {
    setSelectedPath(path: SimplePath) {
      this.selectedPath = path;
      this.editable = false;
      this.selectedPathLengthInMeters = 0;
      this.selectedWorkAreaAreaInSqMeters = 0;
      this.currentLine = [];
    },
    updateCurrentLine(newline: Position[]) {
      this.currentLine = newline;
    },
    setAvailablePaths(paths: Array<SimplePath>) {
      this.paths = paths;
    },
    toggleEditable() {
      this.editable = !this.editable;
    },
    setSelectedPathLength(pathLength: number) {
      this.selectedPathLengthInMeters = pathLength;
    },
    setSelectedWorkAreaArea(area: number) {
      this.selectedWorkAreaAreaInSqMeters = area;
    },
    setSelectedField(field: FieldOperationsModel) {
      this.pathAssociatedField = field;
    },
    triggerClearMap() {
      this.clearMap = !this.clearMap;
    },
    setAddPathMode(value: boolean) {
      this.addPath = value;
    },
    triggerRevertPath() {
      this.revertPath = !this.revertPath;
    },
    triggerRevertWorkArea() {
      this.revertWorkArea = !this.revertWorkArea;
    },
    setEditWorkArea(value: boolean) {
      this.editWorkArea = value;
    },
    triggerWorkAreaDelete() {
      this.currentWorkArea = [];
      this.selectedWorkAreaAreaInSqMeters = 0;
      this.deleteWorkArea = !this.deleteWorkArea;
    },
    setCurrentWorkArea(workArea: Position[]) {
      this.currentWorkArea = workArea;
    }
  }
});
